import React from "react";
import { H4 } from "../../../../AbstractElements";
import { FormGroup, Label } from "reactstrap";

export default function ListingPermissions({ register, handleAll }) {
  return (
    <>
      <H4 attrH4={{ className: "mb-3 mt-2" }}>Listas</H4>
      <FormGroup className="m-t-15 m-checkbox-inline m-0">
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="list_list"
            type="checkbox"
            {...register("permissions.list_list", {})}
          />
          <Label for="list_list">
            {Option}
            <span className="digits"> Ver</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="create_list"
            type="checkbox"
            {...register("permissions.create_list", {})}
          />
          <Label for="create_list">
            {Option}
            <span className="digits"> Crear</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="edit_list"
            type="checkbox"
            {...register("permissions.edit_list", {})}
          />
          <Label for="edit_list">
            {Option}
            <span className="digits"> Modificar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="delete_list"
            type="checkbox"
            {...register("permissions.delete_list", {})}
          />
          <Label for="delete_list">
            {Option}
            <span className="digits"> Eliminar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            onChange={handleAll}
            className="p-0 m-0"
            id="list"
            type="checkbox"
          />
          <Label for="list">
            {Option}
            <span className="digits"> Todos</span>
          </Label>
        </div>
      </FormGroup>
    </>
  );
}
